var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.1 18.1",
    style: {
      enableBackground: "new 0 0 18.1 18.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#929292;stroke:#929292;stroke-width:0.3;}\r\n\t.st2{fill:none;stroke:#929292;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#929292;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.1,7.4H2.4c-0.7,0-1.2-0.5-1.2-1.2V2.4c0-0.7,0.5-1.2,1.2-1.2h3.8c0.7,0,1.2,0.5,1.2,1.2v3.8 C7.3,6.9,6.8,7.4,6.1,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,7.4h-3.8c-0.7,0-1.2-0.5-1.2-1.2V2.4c0-0.7,0.5-1.2,1.2-1.2H15c0.7,0,1.2,0.5,1.2,1.2v3.8 C16.2,6.9,15.7,7.4,15,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.1,16H2.4c-0.7,0-1.2-0.5-1.2-1.2V11c0-0.7,0.5-1.2,1.2-1.2h3.8c0.7,0,1.2,0.5,1.2,1.2v3.8 C7.3,15.4,6.8,16,6.1,16z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13,
    cy: 12.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 15.2,
    y1: 15.1,
    x2: 17,
    y2: 16.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.62c439ab9eca6e3789921ef2d9f0260a.svg";
export { ForwardRef as ReactComponent };